export default "__VITE_ASSET__YH0InzTG__"